import { render } from "./singleBlockInput.vue?vue&type=template&id=51221003"
import script from "./singleBlockInput.vue?vue&type=script&lang=js"
export * from "./singleBlockInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__